<template lang="pug">
  .snowFall
    canvas(ref="snowFall")
</template>

<script>
export default {
  name: "SnowFall",
  methods: {
    initSnowFall() {
      let canvas = {
        el: this.$refs.snowFall,
        ctx: null,
        width: null,
        height: null,
        images: {},
        imagesCount: 41,
        currentImage: 0
      };
      init();

      function init() {
        canvas.ctx = canvas.el.getContext('2d');
        canvas.width = canvas.el.offsetWidth;
        canvas.height = canvas.el.offsetHeight;
        canvas.el.width = canvas.width;
        canvas.el.height = canvas.height;

        var _loop = function _loop(i) {
          var img = new Image();

          img.src = require('@/assets/img/snowFall/snow_fall_'+String(i).padStart(5, 0)+'.png');

          img.onload = function () {
            canvas.images[i] = img;

            if (Object.keys(canvas.images).length === canvas.imagesCount) {
              render();
            }
          };
        };

        for (var i = 0; i < canvas.imagesCount; i++) {
          _loop(i);
        }
      }

       const update = () => {
        canvas.currentImage++;

        if (canvas.currentImage === canvas.imagesCount) {
          canvas.currentImage = 0;
        }

        //requestAnimationFrame(render);
        let frameK = this.$store.state.isMobileOrTablet ? 25 : 50;
        setTimeout(function () {
          requestAnimationFrame(render);
        }, 1000 / frameK);
      }

      function render() {
        canvas.ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.ctx.drawImage(canvas.images[canvas.currentImage], 0, 0, 1920, 1080, 0, 0, canvas.width, canvas.height);
        update();
      }
    }

  },
  mounted() {
    this.initSnowFall();
  }
}
</script>

<style scoped lang="scss">
  .snowFall {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    canvas{
      width: 100%;
      height: 100%;
    }
    @include mobile_or_P {
      right: initial;
      width: 100vh;
    }
  }
</style>